module.exports = __webpack_public_path__ + "img/magnifying-glass.9147db94.svg";